<template>
  <div class="soil-test">
    <div class="html2pdf__page-break">
      <MainHeader>
        {{$ml.get('Soil test')}}
      </MainHeader>
      
      <GeneralInfo/>
      <Parameters/>
      <Interpretations/>
    </div>
    <div class="html2pdf__page-break">
      <NutChart/>
    </div>
    
  </div>
</template>

<script>
import GeneralInfo from './../components/soil-test/GeneralInfo';
import NutChart from './../components/soil-test/NutChart';
import Interpretations from './../components/soil-test/Interpretations';
import Parameters from './../components/soil-test/Parameters';
import MainHeader from './../components/common/MainHeader';

export default {
  components: {
    GeneralInfo,
    Interpretations,
    Parameters,
    MainHeader,
    NutChart,
  }
}
</script>

<style lang="scss" scoped>

.soil-test {
  .head-line {
    margin-bottom: 10px;
  }
}

</style>